import { inject, Ref } from 'vue';
import { Emitter } from 'mitt';

export const gridPageStateSymbol = Symbol('gridPageState');
export interface GridPageState {
  context: Ref<any>;
  eventBus: Emitter<Record<string, any>>;
}
export const useGridPageState = (): GridPageState => {
  const state = inject<GridPageState>(gridPageStateSymbol);
  return state;
};
